import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';

import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => (
    {
        root: props => ({
            padding: theme.spacing(props.spacing),
            width: "fit-content",
            position: props.position,
            right: 0,
            bottom: 0,
            '& > *': {
                margin: theme.spacing(1),
            },
        }),
        fab: props => ({
            backgroundColor: props.background,
            " & svg": {
                fill: props.iconColor && !props.color ? props.iconColor : ""
            }
        }),
        icon: props => ({
            marginRight: props.variant === "expanded" ? theme.spacing(1) : theme.spacing(0),
        }),
    }
));

const FloatingAction = props => {
    const classes = useStyles(props);

    const { text, iconComponent: Component, onActionClick } = props

    const handleClick = (e, id) => {
        onActionClick(id)
    }

    return (
        <div className={classes.root}>
            <Fab {...props} className={classes.fab} onClick={(e) => handleClick(e, props.id)} >
                {Component && <Component className={classes.icon} />}
                {text}
            </Fab>
        </div>
    )
}

FloatingAction.propTypes = {
    variant: PropTypes.oneOf(["extended", "round"]),
    color: PropTypes.oneOf(["primary", "secondary", "inherit", "default"]),
    /**
     * Raw format color
     * Overrides theme color of background
     */
    background: PropTypes.string,
    /**
     * Raw format color
     * Overrides theme color of svg icon
     */
    iconColor: PropTypes.string,
    /**
     * Handles onclick call returns (e)=>{}
     */
    onActionClick: PropTypes.func
}


FloatingAction.defaultProps = {
    spacing: 0,
    variant: "round",
    color: "default",
    iconColor: "#fff",
    position: "fixed",
    onActionClick: (id) => console.log("define click for", id)
};

export default FloatingAction
